import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {produce} from 'immer';
import {createSelectors} from '../lib/createStoreSelectors';

export type Alert = {
    text: string;
    dismissible: boolean;
    fading: boolean;
    audible: boolean;
    type: 'info' | 'success' | 'warning' | 'error'
    id: string;
}

type AlertsStore = {
    alerts: Array<Alert>;
    addAlert: (alert: Alert | Alert[]) => void;
    removeAlert: (id: string | ((k: Alert) => boolean)) => void;
    hasAudible: () => boolean;
}

const useAlertsStoreBase = create<AlertsStore>()(
    immer(
        (set, get) => ({
            alerts: [],
            addAlert: (alert: Alert | Alert[]) => {
                set((state) => state.alerts.concat([alert].flat()));
            },
            removeAlert: (id: string | ((k:Alert) => boolean)) => {
                set((state) => {
                    if (typeof id === 'function') {
                        state.alerts = state.alerts.filter(id);
                    }else{
                        state.alerts = state.alerts.filter((alert) => alert.id == id)
                    }
                });
            },
            hasAudible: () => {
                return get().alerts.some(alert => alert.audible);
            }
        })
    )
)

export const useAlertsStore = createSelectors(useAlertsStoreBase);
